import './App.css';

function App() {
  return (
    <div className="h-dvh flex items-center justify-center bg-gray-100 text-center p-4">
      <div className="bg-white rounded-2xl shadow-lg p-10 max-w-md w-full">
        <img
          src="https://viptoursistanbul.com/imgs/logo2.svg"
          alt="VIP Tours Istanbul Logo"
          className="mx-auto mb-6 max-w-[220px]"
        />
        <h1 className="text-2xl font-semibold text-gray-800 mb-4">
          Welcome to VIP Tours Istanbul
        </h1>
        <a
          href="https://viptoursistanbul.com?ref=istanbulviptour"
          className="inline-block mt-4 px-6 py-3 bg-black text-white rounded-lg text-lg hover:bg-gray-800 transition"
        >
          Visit Our Main Website
        </a>
      </div>
    </div>
  );
}

export default App;
